export default __webpack_public_path__ + "static/media/green_drop.53c09932.svg";